import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Tag } from "antd";

export function TestCaseTagsNew({ tags }) {
  // console.log({ tags });
  const tagColors = [
    "pink",
    "orange",
    "green",
    "red",
    "cyan",
    "blue",
    "purple"
  ];

  const showTags = tags => {
    if (!tags) return null;
    if (tags && tags.length == 0) return null;
    return tags.map((tag, index) => (
      <Tag key={tag.id} color={tagColors[tag.id % tagColors.length]}>
        {tag.name}
      </Tag>
    ));
  };

  return <div>{showTags(tags)}</div>;
}
//export default hot(module)(TestCaseTagsNew)

class TestCaseTags extends React.Component {
  render() {
    const tagColors = [
      "pink",
      "orange",
      "green",
      "red",
      "cyan",
      "blue",
      "purple"
    ];

    const showTags = tags => {
      if (!tags) return null;
      if (tags.length == 0) return null;
      // console.log({ tags_CHECK: tags });
      return tags.map((tag, index) => (
        <Tag key={tag.id} color={tagColors[tag.id % tagColors.length]}>
          {unescape(tag.name)}
        </Tag>
      ));
    };

    return <div>{showTags(this.props.testCase.tags)}</div>;
  }
}

export default TestCaseTags;
